import { useEffect, useState, useMemo } from 'react';

export const useIsShowingEllipsis = <T extends HTMLElement | null = HTMLElement | null>() => {
  const [element, setElement] = useState<T>();

  const [isShowingEllipsis, setIsShowingEllipsis] = useState(false);

  const resizeObserver = useMemo(
    () =>
      new ResizeObserver((entries) => {
        if (entries.length) {
          const [textWrapperEntry] = entries;
          const el = textWrapperEntry.target;
          setIsShowingEllipsis(el?.scrollWidth > el?.clientWidth);
        }
      }),
    [],
  );

  useEffect(() => {
    if (element) {
      setIsShowingEllipsis(element.scrollWidth > element.clientWidth);
      resizeObserver.observe(element);
    }
    return () => {
      if (element) {
        resizeObserver.unobserve(element);
      }
    };
  }, [resizeObserver, element]);

  return { setElement, isShowingEllipsis };
};
